import React, { FunctionComponent, useState } from 'react'

import styles from './styles.module.css'
import clsx from 'clsx'

interface Props {
  src?: string
  alt?: string
  testNameSpace?: string
}

enum ImageState {
  Loading,
  Loaded,
}

export const QRCode: FunctionComponent<Props> = ({ src = '', alt = '', testNameSpace = '' }) => {
  const isSrcAvailable = src.length > 0
  const [imageState, setImageState] = useState<ImageState>(ImageState.Loading)
  const testid = testNameSpace.length > 0 ? `${testNameSpace}-qr-code` : 'qr-code'

  const handleImageLoad = (): void => {
    setImageState(ImageState.Loaded)
  }

  const componentStyle = clsx(styles.img, imageState === ImageState.Loaded && styles.ready)

  if (!isSrcAvailable) {
    return null
  }

  return <img data-testid={testid} src={src} className={componentStyle} alt={alt} width={182} height={182} onLoad={handleImageLoad} />
}
